import { getListOfRCSPrice, editRCSPrice } from "../types/gateway_and_price_list_rcs_types";

export const getListOfRCSPriceRequest = (payload, cb) => ({
  type: getListOfRCSPrice.GET_LIST_OF_RCS_PRICE_REQUEST,
  payload,
  cb,
});
export const getListOfRCSPriceSuccess = (payload) => ({
  type: getListOfRCSPrice.GET_LIST_OF_RCS_PRICE_SUCCESS,
  payload,
});
export const getListOfRCSPriceError = (payload) => ({
  type: getListOfRCSPrice.GET_LIST_OF_RCS_PRICE_ERROR,
  payload,
});

export const editRCSPriceRequest = (payload, cb) => ({
  type: editRCSPrice.EDIT_RCS_PRICE_REQUEST,
  payload,
  cb,
});
export const editRCSPriceSuccess = (payload) => ({
  type: editRCSPrice.EDIT_RCS_PRICE_SUCCESS,
  payload,
});
export const editRCSPriceError = (payload) => ({
  type: editRCSPrice.EDIT_RCS_PRICE_ERROR,
  payload,
});
